module.exports = __webpack_public_path__ + "img/SKMJ_etc8.c1077204.jpg";